import { render, staticRenderFns } from "./profit-report-table-template.vue?vue&type=template&id=4ad0ced3&scoped=true&"
import script from "./profit-report-table-template.vue?vue&type=script&lang=js&"
export * from "./profit-report-table-template.vue?vue&type=script&lang=js&"
import style0 from "./profit-report-table-template.vue?vue&type=style&index=0&id=4ad0ced3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ad0ced3",
  null
  
)

export default component.exports